// extracted by mini-css-extract-plugin
module.exports = {"title":"index_title__3Rrub","site":"index_site__11yG2","page":"index_page__2JoaZ","table":"index_table__3m_2l"};